import React from "react";

const TempGoalsKamuMobile = ({ children }) => {
  return <div className="pb-4">{children}</div>;
};

export default TempGoalsKamuMobile;
